
import { makeAutoObservable } from 'mobx';
type PropertyType = {
    id_okno_properties:number,
    okno_title:string,
    okno_pole:string,
    id_okno:number,
    id_student:number,
    dolg:number,
    pole:number,
    visibility:number
}
type PaymentType = {
        id_a_year: number,
        p32: string,
        id_faculty: number,
        id_rate: number,
        p22: string,
        id_group: number,
        p20: string,
        id_student: number,
        s_fio: string,
        sh_st: string,
        p106: number,
        sum_opl: number,
        dolg: number,
        p25_2: string,
        come_date: string,
        spec: string,
        percent_privilege: number,
        privilege_coment: number,
        priv_var: number,
        id_speciality: number,
        id_spec: number,
        opl: boolean
}

    type StudentInfType = {
        v2: string;
        s_fio: string;
        groups: string;
        idid: string;
    }


    type MaleType = {
        Male: boolean
    }

export interface DescriptionType {
    id_okno_description: number
    id_student: number
    id_user: number
    okno_description: string
}

export interface AccessPropertyType{
    pole: string,
    visibles: boolean
}


class Property{
    properties: PropertyType[] = []
    payment: PaymentType[] = []
    description: DescriptionType[] = []
    delDesc: boolean = false
    studentInf: StudentInfType = {
        v2: '',
        s_fio: '',
        groups: '',
        idid: ''
    }
    male: MaleType = {
        Male: false
    }
    accessProperty: AccessPropertyType[] = [
        { pole: "ckb",visibles : true },
        { pole: "dekanat",visibles : true },
        { pole: "KjMTB",visibles : true },
        { pole: "obshejitie",visibles : true },
        { pole: "biblioteka",visibles : false },
        { pole: "Buhgalteriy",visibles : false },
        { pole: "pole1",visibles : true },
        { pole: "pole2",visibles : false },
        { pole: "pole3",visibles : false }
    ]
    tempVar = {Buhgalteriy: false,
        KjMTB: false,
        biblioteka: false,
        ckb: false,
        dekanat: false,
        id_group: 10234,
        id_student: 173196,
        obshejitie: false,
        pole1: false,
        pole2: false,
        pole3: false}
   
    constructor(){
        makeAutoObservable(this)
    }

    newProperties(param: PropertyType[]){
        this.properties = param;
    }

    newPayment(param: PaymentType[]){
        this.payment = param
    }

    newStudentInf(param: StudentInfType){
        this.studentInf = param
    }

    newMale(param: MaleType){
        this.male = param
    }

    newDescription(param: DescriptionType[]){
        this.description = param
    }

    setDelDesc( param: boolean ){
        this.delDesc = param
    }

    newAccessProperty(param: AccessPropertyType[]){
        this.accessProperty = param
    }

    newTempVar(param: any){
        this.tempVar = param
    }

}

export const property = new Property()